const CHANNEL_DATA = [
    { name: "商城", path: "channel" },
    { name: "分类", path: "channel" },
    { name: "订单", path: "channel" },
    { name: "黄金订单频道", path: "gold-order" },
    { name: "黄金回购频道", path: "gold-repo" },
    { name: "黄金我的频道", path: "gold-my" },
    { name: "展示设置", path: "setting" },
    { name: "伴读我的", path: "c-bandu-my" },
    { name: "伴读", path: "c-bandu" },
    { name: "图书", path: "c-library" },
    { name: "阅读我的", path: "read-my" },
    { name: "阅读", path: "read-zixun" },
    { name: "操盘", path: "read-caopan" },
    { name: "公共服务", path: "kf-publish" },
    { name: "自营服务", path: "kf-ziying" },
    { name: "康护我的", path: "kf-my" },
  ];
  export default CHANNEL_DATA;


// WEBPACK FOOTER //
// ./src/utils/channel.js